import React from "react";
import { Link } from "react-router-dom";

import avatar26 from "../../assets/images/avatar-26.png";
import avatar27 from "../../assets/images/avatar-27.png";
import avatar20 from "../../assets/images/avatar-20.png";
import avatar10 from "../../assets/images/avatar-10.png";
import avatar16 from "../../assets/images/avatar-16.png";
import avatar2 from "../../assets/images/avatar-2.png";
import avatar19 from "../../assets/images/avatar-19.png";
import avatar18 from "../../assets/images/avatar-18.png";
import avatar8 from "../../assets/images/avatar-8.png";

const LeadsClientActivity = () => {
  return (
    <React.Fragment>
      <div className="grid grid-cols-1 gap-4 md:grid-cols-1">
        <div className="gap-6 p-5 bg-white border rounded dark:bg-darklight dark:border-darkborder border-black/10">
          <h2 className="mb-4 text-base font-semibold text-black capitalize dark:text-white/80">
            Leads & Client Activity
          </h2>
          <div className="overflow-auto">
            <table className="min-w-[640px] w-full">
              <thead>
                <tr className="ltr:text-left rtl:text-right">
                  <th>Project Name</th>
                  <th>Work Timeline</th>
                  <th>Project Team</th>
                  <th>Project Type</th>
                  <th>Status</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                <tr className="text-muted">
                  <td>Chat App Development</td>
                  <td>05 Feb, 2024 - 06 April, 2024</td>
                  <td>
                    <div className="flex items-center -space-x-2 rtl:space-x-reverse">
                      <Link to="#!">
                        <img
                          src={avatar27}
                          alt=""
                          className="border-2 border-white rounded-full dark:border-darklight size-7"
                        />
                      </Link>
                      <Link to="#!">
                        <img
                          src={avatar26}
                          alt=""
                          className="border-2 border-white rounded-full dark:border-darklight size-7"
                        />
                      </Link>
                      <Link to="#!">
                        <img
                          src={avatar20}
                          alt=""
                          className="border-2 border-white rounded-full dark:border-darklight size-7"
                        />
                      </Link>
                      <Link to="#!">
                        <div className="flex items-center justify-center text-xs text-white border-2 border-white rounded-full dark:border-darklight bg-purple size-7">
                          2+
                        </div>
                      </Link>
                    </div>
                  </td>
                  <td>React + Mongodb</td>
                  <td>
                    <span className="px-2 py-1 text-xs font-bold rounded bg-info/10 text-info">
                      Inprogress
                    </span>
                  </td>
                  <td>
                    <div className="flex items-center gap-3">
                      <Link
                        to="#!"
                        className="transition duration-200 ease-linear text-muted hover:text-success"
                      >
                        <i className="ri-eye-line"></i>
                      </Link>
                      <Link
                        to="#!"
                        className="transition duration-200 ease-linear text-muted hover:text-purple"
                      >
                        <i className="ri-edit-line"></i>
                      </Link>
                      <Link
                        to="#!"
                        className="transition duration-200 ease-linear text-muted hover:text-danger"
                      >
                        <i className="ri-delete-bin-line"></i>
                      </Link>
                    </div>
                  </td>
                </tr>
                <tr className="text-muted">
                  <td>Redesign for Business Website</td>
                  <td>20 Feb, 2024 - 12 March, 2024</td>
                  <td>
                    <div className="flex items-center -space-x-2 rtl:space-x-reverse">
                      <Link to="#!">
                        <img
                          src={avatar10}
                          alt=""
                          className="border-2 border-white rounded-full dark:border-darklight size-7"
                        />
                      </Link>
                      <Link to="#!">
                        <img
                          src={avatar16}
                          alt=""
                          className="border-2 border-white rounded-full dark:border-darklight size-7"
                        />
                      </Link>
                    </div>
                  </td>
                  <td>VueJs</td>
                  <td>
                    <span className="px-2 py-1 text-xs font-bold text-blue-500 rounded bg-blue-500/10">
                      New
                    </span>
                  </td>
                  <td>
                    <div className="flex items-center gap-3">
                      <Link
                        to="#!"
                        className="transition duration-200 ease-linear text-muted hover:text-success"
                      >
                        <i className="ri-eye-line"></i>
                      </Link>
                      <Link
                        to="#!"
                        className="transition duration-200 ease-linear text-muted hover:text-purple"
                      >
                        <i className="ri-edit-line"></i>
                      </Link>
                      <Link
                        to="#!"
                        className="transition duration-200 ease-linear text-muted hover:text-danger"
                      >
                        <i className="ri-delete-bin-line"></i>
                      </Link>
                    </div>
                  </td>
                </tr>
                <tr className="text-muted">
                  <td>HR Management </td>
                  <td>13 Aug, 2024 - 19 Oct, 2024</td>
                  <td>
                    <div className="flex items-center -space-x-2 rtl:space-x-reverse">
                      <Link to="#!">
                        <img
                          src={avatar2}
                          alt=""
                          className="border-2 border-white rounded-full dark:border-darklight size-7"
                        />
                      </Link>
                    </div>
                  </td>
                  <td>PHP</td>
                  <td>
                    <span className="px-2 py-1 text-xs font-bold rounded text-success bg-success/10">
                      Completed
                    </span>
                  </td>
                  <td>
                    <div className="flex items-center gap-3">
                      <Link
                        to="#!"
                        className="transition duration-200 ease-linear text-muted hover:text-success"
                      >
                        <i className="ri-eye-line"></i>
                      </Link>
                      <Link
                        to="#!"
                        className="transition duration-200 ease-linear text-muted hover:text-purple"
                      >
                        <i className="ri-edit-line"></i>
                      </Link>
                      <Link
                        to="#!"
                        className="transition duration-200 ease-linear text-muted hover:text-danger"
                      >
                        <i className="ri-delete-bin-line"></i>
                      </Link>
                    </div>
                  </td>
                </tr>
                <tr className="text-muted">
                  <td>Dental website - Landing page</td>
                  <td>02 Jan, 2024 - 26 Feb, 2024</td>
                  <td>
                    <div className="flex items-center -space-x-2 rtl:space-x-reverse">
                      <Link to="#!">
                        <img
                          src={avatar19}
                          alt=""
                          className="border-2 border-white rounded-full dark:border-darklight size-7"
                        />
                      </Link>
                      <Link to="#!">
                        <img
                          src={avatar20}
                          alt=""
                          className="border-2 border-white rounded-full dark:border-darklight size-7"
                        />
                      </Link>
                      <Link to="#!">
                        <img
                          src={avatar18}
                          alt=""
                          className="border-2 border-white rounded-full dark:border-darklight size-7"
                        />
                      </Link>
                    </div>
                  </td>
                  <td>VueJs + Laravel</td>
                  <td>
                    <span className="px-2 py-1 text-xs font-bold rounded text-info bg-info/10">
                      Inprogress
                    </span>
                  </td>
                  <td>
                    <div className="flex items-center gap-3">
                      <Link
                        to="#!"
                        className="transition duration-200 ease-linear text-muted hover:text-success"
                      >
                        <i className="ri-eye-line"></i>
                      </Link>
                      <Link
                        to="#!"
                        className="transition duration-200 ease-linear text-muted hover:text-purple"
                      >
                        <i className="ri-edit-line"></i>
                      </Link>
                      <Link
                        to="#!"
                        className="transition duration-200 ease-linear text-muted hover:text-danger"
                      >
                        <i className="ri-delete-bin-line"></i>
                      </Link>
                    </div>
                  </td>
                </tr>
                <tr className="text-muted">
                  <td>Hospital Management System</td>
                  <td>09 June, 2024 - 09 Oct, 2024</td>
                  <td>
                    <div className="flex items-center -space-x-2 rtl:space-x-reverse">
                      <Link to="#!">
                        <img
                          src={avatar8}
                          alt=""
                          className="border-2 border-white rounded-full dark:border-darklight size-7"
                        />
                      </Link>
                      <Link to="#!">
                        <img
                          src={avatar19}
                          alt=""
                          className="border-2 border-white rounded-full dark:border-darklight size-7"
                        />
                      </Link>
                      <Link to="#!">
                        <img
                          src={avatar16}
                          alt=""
                          className="border-2 border-white rounded-full dark:border-darklight size-7"
                        />
                      </Link>
                    </div>
                  </td>
                  <td>Asp.Net Core</td>
                  <td>
                    <span className="px-2 py-1 text-xs font-bold rounded text-warning bg-warning/10">
                      Pending
                    </span>
                  </td>
                  <td>
                    <div className="flex items-center gap-3">
                      <Link
                        to="#!"
                        className="transition duration-200 ease-linear text-muted hover:text-success"
                      >
                        <i className="ri-eye-line"></i>
                      </Link>
                      <Link
                        to="#!"
                        className="transition duration-200 ease-linear text-muted hover:text-purple"
                      >
                        <i className="ri-edit-line"></i>
                      </Link>
                      <Link
                        to="#!"
                        className="transition duration-200 ease-linear text-muted hover:text-danger"
                      >
                        <i className="ri-delete-bin-line"></i>
                      </Link>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default LeadsClientActivity;
